<div class="flow-arguments" [formGroup]="form">
  <app-mat-form-field *ngFor="let item of calculatedArguments | keyvalue; trackBy: argTrackBy">
    <input
      appMatInput
      [type]="item.value.inputType"
      [formControlName]="item.key"
      [placeholder]="item.value.placeholder"
    />
    <app-mat-hint *ngIf="item.value.description">{{ item.value.description }}</app-mat-hint>
    <app-mat-error *ngIf="form.get(item.key).invalid">{{ getArgumentErrorMessage(item.key) }}</app-mat-error>
  </app-mat-form-field>
</div>
